import { splitLocale } from '../../locale/localeUtils';
export const fontStyleTokens = () => {
  return {
    default: 'normal',
    accent: 'normal'
  };
};
export const fontStyleTokensNova = (theme, language) => {
  // Split the locale into language, region, and script. Our font family designations contain different combinations of these aspects of the locale.
  const {
    lang
  } = splitLocale(language);
  switch (lang) {
    case 'ar':
    case 'zh':
    case 'ja':
    case 'ko':
    case 'th':
      return {
        default: 'normal',
        accent: 'normal'
      };
    default:
      return {
        default: 'normal',
        accent: theme.baseThemeName === 'high-contrast' ? 'normal' : 'italic'
      };
  }
};
//# sourceMappingURL=fontStyle.js.map